import { render, staticRenderFns } from "./Grados.vue?vue&type=template&id=00edf614&"
import script from "./Grados.vue?vue&type=script&lang=js&"
export * from "./Grados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports